var _path, _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12c0 4.418 7.636 15.347 11.25 20.502.637.892 1.75.892 2.387 0C16.364 27.347 24 16.418 24 12 24 5.373 18.627 0 12 0z",
    fill: "#52c41a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 16,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#52c41a",
    fontWeight: "bold"
  }, "S")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartPin);
export default __webpack_public_path__ + "static/media/start-pin.6eebb2c09435392447ac66caf9ffb1b1.svg";
export { ForwardRef as ReactComponent };